module.exports = __webpack_public_path__ + "img/ph_paper1.3007a6fc.jpg";